/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage25 = createReactComponent("outline", "percentage-25", "IconPercentage25", [["path", { "d": "M21 12a9 9 0 0 0 -9 -9m0 0v9h9", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage25 as default };
//# sourceMappingURL=IconPercentage25.mjs.map
